export const EMPLOYMENT_INCOME_VERIFICATION_TASK_TYPE_TO_TITLE_MAP = {
  voi: 'Verification of Income',
  voe: 'Verification of Employment',
}
